import { put, takeEvery } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import {
  fetchAvailableFormFieldsSuccess,
  fetchAvailableFormFieldsFailed,
  fetchReportSettingsSuccess,
  fetchReportSettingsFailed,
} from '../actions';
import { PaymentReportSettingsTypes } from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};

export function* fetchAvailableFormFields() {
  const url = `${API_BASE_URL}/payments/report-settings/form-fields`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(fetchAvailableFormFieldsSuccess(response.raw));
  } else {
    networkErrorHandler(response?.statusCode, `Failed to fetch form fields: ${response.message}`);
    yield put(fetchAvailableFormFieldsFailed(response.message));
  }
}

export function* fetchReportSettings() {
  const url = `${API_BASE_URL}/payments/report-settings`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(fetchReportSettingsSuccess(response.raw));
  } else {
    networkErrorHandler(response?.statusCode, `Failed to fetch report settings: ${response.message}`);
    yield put(fetchReportSettingsFailed(response.message));
  }
}

export function* getFormFields() {
  yield takeEvery(PaymentReportSettingsTypes.FETCHING_FORM_FIELDS, fetchAvailableFormFields);
}

export function* getReportSettings() {
  yield takeEvery(PaymentReportSettingsTypes.FETCHING_REPORT_SETTINGS, fetchReportSettings);
}
